import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { fbButton } from 'vanilla-sharing';
import { email } from 'vanilla-sharing';
import { whatsapp } from 'vanilla-sharing';

@Component({
  selector: 'app-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss']
})
export class ShareModalComponent implements OnInit {

  image: any;
  imageUrl: any;
  source: any;
  component: any;
  forecastLength: any; 
  timeLength: any;
  title: any;
  view: any;
  application: any;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router
  ) { }

  ngOnInit() {
    // this.component = this.router.url.split('/')[2].toUpperCase();
    // console.log("modal", this.component, this.view)
    this.forecastLength = this.router.url.split('/')[3];
    let forecastLengthTitle = this.forecastLength;
    if (this.forecastLength == '24') {
      this.timeLength = 'HOURS';
    } else if (this.forecastLength == '10') {
      this.timeLength = 'DAYS';
    } else {
      forecastLengthTitle = 5;
      this.timeLength = 'WEEKS';
    }
    if (this.application == 'extremeweather') {
      this.title = '+' + forecastLengthTitle + ' ' + this.timeLength + ' ' + this.component + ' DATA';
    } else if (this.application == 'observedweather') {
      this.title = this.component + '_ACTUAL DATA';
    }
  }

  download(type) {
    let url, description;
    if (this.application == 'extremeweather') {
      url = ProjConstants.API_URL + 'weatherForecast/getReportImage/' + this.source + '/' + this.component + '/' + this.forecastLength + '/null/' + this.view;
      description = this.forecastLength + ' ' + this.timeLength + ' ' + this.component + ' DATA';
    } else if (this.application == 'observedweather') {
      if (this.component == 'RAINFALL') {
        url = ProjConstants.API_URL + 'aw/getReportImage/' + this.component + '/' + this.view;
      } else if (this.component == 'WINDSPEED') {
        url = ProjConstants.API_URL + 'aw/ws/getWindReportImage';
      } else if (this.component == 'TEMPERATURE') {
        url = ProjConstants.API_URL + 'aw/temperature/getTemperatureReportImage';
      } else if (this.component == 'HUMIDITY') {
        url = ProjConstants.API_URL + 'aw/humidity/getHumidityReportImage';
      }
      // url = ProjConstants.API_URL + 'aw/getReportImage/' + this.component + '/' + this.view;
      description = this.component + '_ACTUAL DATA';
    }
    if(type == 'fbButton') {
      fbButton({
        url: url
      });
    }
    if(type == 'email') {
      email({
        url: url,
        title: this.component + this.source +' DATA',
        description: description,
        subject: this.component + ' DATA',
      });
    }
    if(type == 'whatsapp') {
      whatsapp({
        url: url,
        title: description,
      });
    }    
  }

}
